// Quiz baseline
import { QUESTIONS_TYPE } from '../constants/default/quiz';
import type { QuizCollectionModel } from '@/common/models/quiz.model';

// percentStep = 100 / questions count
const percentStep = 3.57;

export const quiz: QuizCollectionModel = {
  0: {
    id: 0,
    progress: 0,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'select_goal_question' },
    prevLink: '/',
    options: [
      {
        id: 0,
        text: { key: 'select_goal_answer_1' },
        nextLink: 1,
        goals: { main: 'goal_erectile_function', additional: 'add_goal_ejaculation_control' },
      },
      {
        id: 1,
        text: { key: 'select_goal_answer_2' },
        nextLink: 101,
        goals: { main: 'goal_ejaculation_control', additional: 'add_goal_erectile_function' },
      },
      {
        id: 2,
        text: { key: 'select_goal_answer_3' },
        description: { key: 'select_goal_answer_3_1' },
        nextLink: 201,
        goals: { main: 'goal_sexual_wellness', additional: '' },
      },
    ],
  },

  // FIRST BRANCH - Improve Erectile Function

  1: {
    id: 1,
    progress: percentStep,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ed_q2_question' },
    prevLink: 0,
    nextLink: 3,
    options: [
      { id: 0, text: { key: 'ed_q2_answer_1' } },
      { id: 1, text: { key: 'ed_q2_answer_2' } },
      { id: 2, text: { key: 'ed_q2_asnwer_3' } },
      { id: 3, text: { key: 'ed_q2_answer_4' } },
    ],
  },
  3: {
    id: 3,
    progress: percentStep * 2,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ed_q3_question' },
    nextLink: 4,
    prevLink: 1,
    options: [
      { id: 0, text: { key: 'ed_q3_answer_1' } },
      { id: 1, text: { key: 'ed_q3_answer_2' } },
      { id: 2, text: { key: 'ed_q3_answer_3' } },
      { id: 3, text: { key: 'ed_q3_answer_4' } },
      { id: 4, text: { key: 'ed_q3_answer_5' } },
    ],
  },
  4: {
    id: 4,
    progress: percentStep * 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ed_q4_question' },
    nextLink: 5,
    prevLink: 3,
    options: [
      { id: 0, text: { key: 'ed_q4_answer_1' } },
      { id: 1, text: { key: 'ed_q4_answer_2' } },
      { id: 2, text: { key: 'ed_q4_answer_3' } },
      { id: 3, text: { key: 'ed_q4_answer_4' } },
      { id: 4, text: { key: 'ed_q4_answer_5' } },
    ],
  },
  5: {
    id: 5,
    progress: percentStep * 4,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ed_q5_question' },
    nextLink: 6,
    prevLink: 4,
    options: [
      { id: 0, text: { key: 'ed_q5_answer_1' } },
      { id: 1, text: { key: 'ed_q5_answer_2' } },
      { id: 2, text: { key: 'ed_q5_answer_3' } },
    ],
  },
  6: {
    id: 6,
    progress: percentStep * 5,
    type: QUESTIONS_TYPE.s1,
    nextLink: 7,
    prevLink: 5,
    s1: {
      title: 'ed_s1_title',
      text: 'ed_s1_body',
      video: {
        path: '/video/video_ED_s1.mp4',
        poster: '/video/posters/img_ED_s1.webp',
        loop: true,
      },
    },
  },
  7: {
    id: 7,
    progress: percentStep * 6,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ed_q6_question' },
    nextLink: 8,
    prevLink: 6,
    options: [
      { id: 0, text: { key: 'ed_q6_answer_1' } },
      { id: 1, text: { key: 'ed_q6_answer_2' } },
      { id: 2, text: { key: 'ed_q6_answer_3' } },
      { id: 3, text: { key: 'ed_q6_answer_4' } },
      { id: 4, text: { key: 'ed_q6_answer_5' } },
    ],
  },
  8: {
    id: 8,
    progress: percentStep * 7,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ed_q7_question' },
    nextLink: 9,
    prevLink: 7,
    leftRate: { key: 'ed_q7_rate_low' },
    rightRate: { key: 'ed_q7_rate_high' },
  },
  9: {
    id: 9,
    progress: percentStep * 8,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ed_q8_question' },
    nextLink: 10,
    prevLink: 8,
    leftRate: { key: 'ed_q8_rate_low' },
    rightRate: { key: 'ed_q8_rate_high' },
  },
  10: {
    id: 10,
    progress: percentStep * 9,
    type: QUESTIONS_TYPE.EFFECTIVE_EXERCISES,
    nextLink: 11,
    prevLink: 9,
    s2: {
      title: 'ed_s2_title',
      image: 'img_erection_kegels_nokegels.webp',
      source: {
        logo: 'hospital',
        name: 'ed_s2_source',
        label: 'ed_s2_source_name',
      },
    },
  },
  11: {
    id: 11,
    progress: percentStep * 10,
    type: QUESTIONS_TYPE.KEGEL_EFFECTIVENESS,
    nextLink: 12,
    prevLink: 10,
    s4: {
      title: 'ed_s3_title',
      image: 'img_erection_84.webp',
      review: [7],
      buttons: false,
    },
  },
  12: {
    id: 12,
    progress: percentStep * 11,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ed_q9_question' },
    nextLink: 13,
    prevLink: 11,
    leftRate: { key: 'ed_q9_rate_low' },
    rightRate: { key: 'ed_q9_rate_high' },
  },
  13: {
    id: 13,
    progress: percentStep * 12,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ed_q10_question' },
    nextLink: 14,
    prevLink: 12,
    leftRate: { key: 'ed_q10_rate_low' },
    rightRate: { key: 'ed_q10_rate_high' },
  },
  14: {
    id: 14,
    progress: percentStep * 13,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ed_q11_question' },
    nextLink: 15,
    prevLink: 13,
    leftRate: { key: 'ed_q11_rate_low' },
    rightRate: { key: 'ed_q11_rate_high' },
  },
  15: {
    id: 15,
    progress: percentStep * 14,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ed_q12_question' },
    nextLink: 16,
    prevLink: 14,
    options: [
      { id: 0, text: { key: 'ed_q12_answer_1' } },
      { id: 1, text: { key: 'ed_q12_answer_2' } },
      { id: 2, text: { key: 'ed_q12_answer_3' } },
    ],
  },
  16: {
    id: 16,
    progress: percentStep * 15,
    type: QUESTIONS_TYPE.GOALS_REVIEWS,
    titleKey: 'ed_pp1_title',
    goalKey: 'ed_pp1_improve_goal',
    byDateKey: 'ed_pp1_by_date',
    noteKey: 'ed_pp1_illustration_note',
    reviewsTitleKey: 'ed_pp1_customer_reviews_title',
    showMoreButtonKey: 'ed_pp1_show_more_button',
    nextLink: 17,
    prevLink: 15,
  },
  17: {
    id: 17,
    progress: percentStep * 16,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ed_q13_question' },
    nextLink: 18,
    prevLink: 16,
    options: [
      { id: 0, text: { key: 'ed_q13_answer_1' } },
      { id: 1, text: { key: 'ed_q13_answer_2' } },
      { id: 2, text: { key: 'ed_q13_answer_3' } },
      { id: 3, text: { key: 'ed_q13_answer_4' } },
    ],
  },
  18: {
    id: 18,
    progress: percentStep * 17,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ed_q14_question' },
    prevLink: 17,
    nextLink: 19,
    options: [
      { id: 0, text: { key: 'ed_q14_answer_1' } },
      { id: 1, text: { key: 'ed_q14_answer_2' } },
      { id: 2, text: { key: 'ed_q14_answer_3' } },
      { id: 3, text: { key: 'ed_q14_answer_4' } },
      { id: 4, text: { key: 'ed_q14_answer_5' } },
    ],
  },
  19: {
    id: 19,
    progress: percentStep * 18,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ed_q15_question' },
    addGoalChoice: true,
    prevLink: '/quiz/18/question',
    options: [
      { id: 1, text: { key: 'ed_q15_answer_1' }, nextLink: 20 },
      { id: 0, text: { key: 'ed_q15_answer_2' }, nextLink: 21 },
    ],
  },
  20: {
    id: 20,
    progress: percentStep * 19,
    type: QUESTIONS_TYPE.KEGEL_EFFECTIVENESS,
    prevLink: 19,
    nextLink: 21,
    s4: {
      title: 'ed_s4_title',
      video: {
        path: '/video/video_8outof10.mp4',
        poster: '/video/posters/img_8outof10.webp',
        loop: false,
      },
      review: [8],
      buttons: true,
    },
  },
  21: {
    id: 21,
    progress: percentStep * 20,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ed_q16_question' },
    prevLink: 19,
    nextLink: 22,
    leftRate: { key: 'ed_q16_rate_low' },
    rightRate: { key: 'ed_q16_rate_high' },
  },
  22: {
    id: 22,
    progress: percentStep * 21,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ed_q17_question' },
    prevLink: 21,
    nextLink: 23,
    options: [
      { id: 0, text: { key: 'ed_q17_answer_1' } },
      { id: 1, text: { key: 'ed_q17_answer_2' } },
      { id: 2, text: { key: 'ed_q17_answer_3' } },
      { id: 3, text: { key: 'ed_q17_answer_4' } },
    ],
  },
  23: {
    id: 23,
    progress: percentStep * 22,
    type: QUESTIONS_TYPE.KEGEL_BENEFITS,
    titleKey: 'ed_s5_title',
    sourceKey: 'ed_s5_source',
    sourceNameKey: 'ed_s5_source_name',
    prevLink: 22,
    nextLink: 24,
    s5: {
      base: 'img_pills_vs_kegel_Erection.webp',
      add: 'img_pills_vs_kegel_Erection_Stamina.webp',
    },
  },
  24: {
    id: 24,
    progress: percentStep * 23,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ed_q18_question' },
    prevLink: 23,
    nextLink: 25,
    options: [
      { id: 0, text: { key: 'ed_q18_answer_1' } },
      { id: 1, text: { key: 'ed_q18_answer_2' } },
      { id: 2, text: { key: 'ed_q18_answer_3' } },
      { id: 3, text: { key: 'ed_q18_answer_4' } },
      { id: 4, text: { key: 'ed_q18_answer_5' } },
    ],
  },
  25: {
    id: 25,
    progress: percentStep * 24,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ed_q19_question' },
    prevLink: 24,
    nextLink: 26,
    options: [
      { id: 0, text: { key: 'ed_q19_answer_1' } },
      { id: 1, text: { key: 'ed_q19_answer_2' } },
      { id: 2, text: { key: 'ed_q19_answer_3' } },
    ],
  },
  26: {
    id: 26,
    progress: percentStep * 25,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ed_q20_question' },
    prevLink: 25,
    nextLink: 27,
    leftRate: { key: 'ed_q20_rate_low' },
    rightRate: { key: 'ed_q20_rate_high' },
  },
  27: {
    id: 27,
    progress: percentStep * 26,
    type: QUESTIONS_TYPE.GOALS,
    titleKey: 'ed_pp2_title',
    goalKey: 'ed_pp1_improve_goal',
    addGoalKey: 'ed_pp2_improve_goal',
    byDateKey: 'ed_pp2_by_date',
    noteKey: 'ed_pp2_illustration_note',
    durationKey: 'ed_pp2_exercise_duration',
    equipKey: 'ed_pp2_required_equipment',
    exNoteKey: 'ed_pp2_exercise_note',
    prevLink: 26,
    nextLink: 28,
  },
  28: {
    id: 28,
    progress: percentStep * 27,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ed_q_21_question' },
    prevLink: 27,
    nextLink: 29,
    leftRate: { key: 'ed_q21_rate_low' },
    rightRate: { key: 'ed_q21_rate_high' },
  },
  29: {
    id: 29,
    progress: 100,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ed_q_22_question' },
    prevLink: 28,
    nextLink: '/quiz/health-onboarding',
    leftRate: { key: 'ed_q22_rate_low' },
    rightRate: { key: 'ed_q22_rate_high' },
  },

  // SECOND BRANCH - Improve Ejaculation Control

  101: {
    id: 101,
    progress: percentStep,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'pe_q2_question' },
    prevLink: 0,
    nextLink: 102,
    options: [
      { id: 0, text: { key: 'pe_q2_answer_1' } },
      { id: 1, text: { key: 'pe_q2_answer_2' } },
      { id: 2, text: { key: 'pe_q2_answer_3' } },
      { id: 3, text: { key: 'pe_q2_answer_4' } },
    ],
  },
  102: {
    id: 102,
    progress: percentStep * 2 + 2,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'pe_q3_question' },
    prevLink: 101,
    nextLink: 103,
    options: [
      { id: 0, text: { key: 'pe_q3_answer_1' } },
      { id: 1, text: { key: 'pe_q3_answer_2' } },
      { id: 2, text: { key: 'pe_q3_answer_3' } },
      { id: 3, text: { key: 'pe_q3_answer_4' } },
      { id: 4, text: { key: 'pe_q3_answer_5' } },
    ],
  },
  103: {
    id: 103,
    progress: percentStep * 3 + 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'pe_q4_question' },
    prevLink: 102,
    nextLink: 104,
    options: [
      { id: 0, text: { key: 'pe_q4_answer_1' } },
      { id: 1, text: { key: 'pe_q4_answer_2' } },
      { id: 2, text: { key: 'pe_q4_answer_3' } },
      { id: 3, text: { key: 'pe_q4_answer_4' } },
    ],
  },
  104: {
    id: 104,
    progress: percentStep * 4 + 3,
    type: QUESTIONS_TYPE.s1,
    nextLink: 105,
    prevLink: 103,
    s1: {
      title: 'pe_s1_title',
      text: 'pe_s1_body',
      video: {
        path: '/video/video_PE_s1.mp4',
        poster: '/video/posters/img_PE_s1.webp',
        loop: true,
      },
    },
  },
  105: {
    id: 105,
    progress: percentStep * 5 + 4,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'pe_q5_question' },
    nextLink: 106,
    prevLink: 104,
    leftRate: { key: 'pe_q5_rate_low' },
    rightRate: { key: 'pe_q5_rate_high' },
  },
  106: {
    id: 106,
    progress: percentStep * 6 + 4,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'pe_q6_question' },
    nextLink: 107,
    prevLink: 105,
    leftRate: { key: 'pe_q6_rate_low' },
    rightRate: { key: 'pe_q6_rate_high' },
  },
  107: {
    id: 107,
    progress: percentStep * 7 + 5,
    type: QUESTIONS_TYPE.EFFECTIVE_EXERCISES,
    nextLink: 108,
    prevLink: 106,
    s2: {
      title: 'pe_s2_title',
      image: 'img_sex_duration_kegels_nokegels.webp',
      source: {
        logo: 'sapienza',
        name: 'pe_s2_source',
        label: 'pe_s2_source_name',
      },
    },
  },
  108: {
    id: 108,
    progress: percentStep * 8 + 5,
    type: QUESTIONS_TYPE.KEGEL_EFFECTIVENESS,
    nextLink: 109,
    prevLink: 107,
    s4: {
      title: 'pe_s3_title',
      video: {
        path: '/video/video_8outof10.mp4',
        poster: '/video/posters/img_8outof10.webp',
        loop: false,
      },
      review: [8],
      buttons: false,
    },
  },
  109: {
    id: 109,
    progress: percentStep * 9 + 4,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'pe_q7_question' },
    nextLink: 110,
    prevLink: 108,
    leftRate: { key: 'pe_q7_rate_low' },
    rightRate: { key: 'pe_q7_rate_high' },
  },
  110: {
    id: 110,
    progress: percentStep * 10 + 3,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'pe_q8_question' },
    nextLink: 111,
    prevLink: 109,
    leftRate: { key: 'pe_q8_rate_low' },
    rightRate: { key: 'pe_q8_rate_high' },
  },
  111: {
    id: 111,
    progress: percentStep * 11 + 2,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'pe_q9_question' },
    nextLink: 112,
    prevLink: 110,
    leftRate: { key: 'pe_q9_rate_low' },
    rightRate: { key: 'pe_q9_rate_high' },
  },
  112: {
    id: 112,
    progress: percentStep * 12 + 1,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'pe_q10_question' },
    prevLink: 111,
    nextLink: 113,
    options: [
      { id: 0, text: { key: 'pe_q10_answer_1' } },
      { id: 1, text: { key: 'pe_q10_answer_2' } },
      { id: 2, text: { key: 'pe_q10_answer_3' } },
    ],
  },
  113: {
    id: 113,
    progress: percentStep * 13,
    type: QUESTIONS_TYPE.GOALS_REVIEWS,
    titleKey: 'pe_pp1_title',
    goalKey: 'pe_pp1_improve_goal',
    byDateKey: 'pe_pp1_by_date',
    noteKey: 'pe_pp1_illustration_note',
    reviewsTitleKey: 'pe_pp1_customer_reviews_title',
    showMoreButtonKey: 'pe_pp1_show_more_button',
    prevLink: 112,
    nextLink: 114,
  },
  114: {
    id: 114,
    progress: percentStep * 14,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'pe_q11_question' },
    prevLink: 113,
    nextLink: 115,
    options: [
      { id: 0, text: { key: 'pe_q11_answer_1' } },
      { id: 1, text: { key: 'pe_q11_answer_2' } },
      { id: 2, text: { key: 'pe_q11_answer_3' } },
      { id: 3, text: { key: 'pe_q11_answer_4' } },
    ],
  },
  115: {
    id: 115,
    progress: percentStep * 15,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'pe_q12_question' },
    prevLink: 114,
    nextLink: 116,
    options: [
      { id: 0, text: { key: 'pe_q12_answer_1' } },
      { id: 1, text: { key: 'pe_q12_answer_2' } },
      { id: 2, text: { key: 'pe_q12_answer_3' } },
      { id: 3, text: { key: 'pe_q12_answer_4' } },
      { id: 4, text: { key: 'pe_q12_answer_5' } },
    ],
  },
  116: {
    id: 116,
    progress: percentStep * 16,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'pe_q13_question' },
    prevLink: 115,
    nextLink: 117,
    options: [
      { id: 0, text: { key: 'pe_q13_answer_1' } },
      { id: 1, text: { key: 'pe_q13_answer_2' } },
      { id: 2, text: { key: 'pe_q13_answer_3' } },
      { id: 3, text: { key: 'pe_q13_answer_4' } },
      { id: 4, text: { key: 'pe_q13_answer_5' } },
    ],
  },
  117: {
    id: 117,
    progress: percentStep * 17,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'pe_q14_question' },
    prevLink: 116,
    nextLink: 118,
    options: [
      { id: 0, text: { key: 'pe_q14_answer_1' } },
      { id: 1, text: { key: 'pe_q14_answer_2' } },
      { id: 2, text: { key: 'pe_q14_answer_3' } },
      { id: 3, text: { key: 'pe_q14_answer_4' } },
    ],
  },
  118: {
    id: 118,
    progress: percentStep * 18,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'pe_q15_question' },
    prevLink: 117,
    addGoalChoice: true,
    options: [
      { id: 1, text: { key: 'pe_q15_answer_1' }, nextLink: 119 },
      { id: 0, text: { key: 'pe_q15_answer_2' }, nextLink: 120 },
    ],
  },
  119: {
    id: 119,
    progress: percentStep * 19,
    type: QUESTIONS_TYPE.KEGEL_EFFECTIVENESS,
    nextLink: 120,
    prevLink: 118,
    s4: {
      title: 'pe_s4_title',
      image: 'img_erection_84.webp',
      review: [7],
      buttons: true,
    },
  },
  120: {
    id: 120,
    progress: percentStep * 20,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'pe_q16_question' },
    prevLink: 118,
    nextLink: 121,
    leftRate: { key: 'pe_q16_rate_low' },
    rightRate: { key: 'pe_q16_rate_high' },
  },
  121: {
    id: 121,
    progress: percentStep * 21,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'pe_q17_question' },
    prevLink: 120,
    nextLink: 122,
    options: [
      { id: 0, text: { key: 'pe_q17_answer_1' } },
      { id: 1, text: { key: 'pe_q17_answer_2' } },
      { id: 2, text: { key: 'pe_q17_answer_3' } },
      { id: 3, text: { key: 'pe_q17_answer_4' } },
    ],
  },
  122: {
    id: 122,
    progress: percentStep * 22,
    type: QUESTIONS_TYPE.KEGEL_BENEFITS,
    titleKey: 'pe_s5_title',
    sourceKey: 'pe_s5_source',
    sourceNameKey: 'pe_s5_source_name',
    nextLink: 123,
    prevLink: 121,
    s5: {
      base: 'img_pills_vs_kegel_stamina.webp',
      add: 'img_pills_vs_kegel_stamina_erection.webp',
    },
  },
  123: {
    id: 123,
    progress: percentStep * 23,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'pe_q18_question' },
    prevLink: 122,
    nextLink: 124,
    options: [
      { id: 0, text: { key: 'pe_q18_answer_1' } },
      { id: 1, text: { key: 'pe_q18_answer_2' } },
      { id: 2, text: { key: 'pe_q18_answer_3' } },
      { id: 3, text: { key: 'pe_q18_answer_4' } },
      { id: 4, text: { key: 'pe_q18_answer_5' } },
    ],
  },
  124: {
    id: 124,
    progress: percentStep * 24,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'pe_q19_question' },
    prevLink: 123,
    nextLink: 125,
    options: [
      { id: 0, text: { key: 'pe_q19_answer_1' } },
      { id: 1, text: { key: 'pe_q19_answer_2' } },
      { id: 2, text: { key: 'pe_q19_answer_3' } },
    ],
  },
  125: {
    id: 125,
    progress: percentStep * 25,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'pe_q20_question' },
    prevLink: 124,
    nextLink: 126,
    leftRate: { key: 'pe_q20_rate_low' },
    rightRate: { key: 'pe_q20_rate_high' },
  },
  126: {
    id: 126,
    progress: percentStep * 26,
    type: QUESTIONS_TYPE.GOALS,
    titleKey: 'pe_pp2_title',
    goalKey: 'pe_pp1_improve_goal',
    addGoalKey: 'pe_pp2_improve_goal',
    byDateKey: 'pe_pp2_by_date',
    noteKey: 'pe_pp2_illustration_note',
    durationKey: 'pe_pp2_exercise_duration',
    equipKey: 'pe_pp2_required_equipment',
    exNoteKey: 'pe_pp2_exercise_note',
    prevLink: 125,
    nextLink: 127,
  },
  127: {
    id: 127,
    progress: percentStep * 27,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'pe_q21_question' },
    prevLink: 126,
    nextLink: 128,
    leftRate: { key: 'pe_q21_rate_low' },
    rightRate: { key: 'pe_q21_rate_high' },
  },
  128: {
    id: 128,
    progress: 100,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'pe_q22_question' },
    prevLink: 127,
    nextLink: '/quiz/health-onboarding',
    leftRate: { key: 'pe_q22_rate_low' },
    rightRate: { key: 'pe_q22_rate_high' },
  },

  // THIRD BRANCH - Maximize Sexual Wellness (Improve both of the above)

  201: {
    id: 201,
    progress: percentStep,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ok_q2_question' },
    nextLink: 202,
    prevLink: 0,
    leftRate: { key: 'ok_q2_rate_low' },
    rightRate: { key: 'ok_q2_rate_high' },
  },
  202: {
    id: 202,
    progress: percentStep * 2 + 2,
    type: QUESTIONS_TYPE.s1,
    isFastAnswer: true,
    nextLink: 203,
    prevLink: 201,

    s1: {
      title: 'ok_s1_title',
      text: 'ok_s1_body',
      video: {
        path: '/video/video_PE_s1.mp4',
        poster: '/video/posters/img_PE_s1.webp',
        loop: true,
      },
    },
  },
  203: {
    id: 203,
    progress: percentStep * 3 + 3,
    type: QUESTIONS_TYPE.s1,
    nextLink: 204,
    prevLink: 202,
    s1: {
      title: 'ok_s2_title',
      text: 'ok_s2_body',
      video: {
        path: '/video/video_ED_s1.mp4',
        poster: '/video/posters/img_ED_s1.webp',
        loop: true,
      },
    },
  },
  204: {
    id: 204,
    progress: percentStep * 4 + 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ok_q3_question' },
    prevLink: 203,
    nextLink: 205,
    options: [
      { id: 0, text: { key: 'ok_q3_answer_1' } },
      { id: 1, text: { key: 'ok_q3_answer_2' } },
      { id: 2, text: { key: 'ok_q3_answer_3' } },
      { id: 3, text: { key: 'ok_q3_answer_4' } },
    ],
  },
  205: {
    id: 205,
    progress: percentStep * 5 + 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ok_q4_question' },
    prevLink: 204,
    nextLink: 206,
    options: [
      { id: 0, text: { key: 'ok_q4_answer_1' } },
      { id: 1, text: { key: 'ok_q4_answer_2' } },
      { id: 2, text: { key: 'ok_q4_answer_3' } },
      { id: 3, text: { key: 'ok_q4_answer_4' } },
      { id: 4, text: { key: 'ok_q4_answer_5' } },
    ],
  },
  206: {
    id: 206,
    progress: percentStep * 6 + 4,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ok_q5_question' },
    prevLink: 205,
    nextLink: 207,
    options: [
      { id: 0, text: { key: 'ok_q5_answer_1' } },
      { id: 1, text: { key: 'ok_q5_answer_2' } },
      { id: 2, text: { key: 'ok_q5_answer_3' } },
      { id: 3, text: { key: 'ok_q5_answer_4' } },
    ],
  },
  207: {
    id: 207,
    progress: percentStep * 7 + 4,
    type: QUESTIONS_TYPE.EFFECTIVE_EXERCISES,
    nextLink: 208,
    prevLink: 206,
    s2: {
      title: 'ok_s3_title',
      image: 'img_sex_duration_7x.webp',
      source: {
        logo: 'sapienza',
        name: 'ok_s3_source',
        label: 'ok_s3_source_name',
      },
    },
  },
  208: {
    id: 208,
    progress: percentStep * 8 + 5,
    type: QUESTIONS_TYPE.KEGEL_EFFECTIVENESS,
    nextLink: 209,
    prevLink: 207,
    s4: {
      title: 'ok_s4_title',
      video: {
        path: '/video/video_8outof10.mp4',
        poster: '/video/posters/img_8outof10.webp',
        loop: false,
      },
      review: [8],
      buttons: false,
    },
  },
  209: {
    id: 209,
    progress: percentStep * 9 + 4,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ok_q6_question' },
    prevLink: 208,
    nextLink: 210,
    options: [
      { id: 0, text: { key: 'ok_q6_answer_1' } },
      { id: 1, text: { key: 'ok_q6_answer_2' } },
      { id: 2, text: { key: 'ok_q6_answer_3' } },
      { id: 3, text: { key: 'ok_q6_answer_4' } },
    ],
  },
  210: {
    id: 210,
    progress: percentStep * 10 + 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ok_q7_question' },
    prevLink: 209,
    nextLink: 211,
    options: [
      { id: 0, text: { key: 'ok_q7_answer_1' } },
      { id: 1, text: { key: 'ok_q7_answer_2' } },
      { id: 2, text: { key: 'ok_q7_answer_3' } },
      { id: 3, text: { key: 'ok_q7_answer_4' } },
      { id: 4, text: { key: 'ok_q7_answer_5' } },
    ],
  },
  211: {
    id: 211,
    progress: percentStep * 11 + 2,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ok_q8_question' },
    prevLink: 210,
    nextLink: 212,
    options: [
      { id: 0, text: { key: 'ok_q8_answer_1' } },
      { id: 1, text: { key: 'ok_q8_answer_2' } },
      { id: 2, text: { key: 'ok_q8_answer_3' } },
      { id: 3, text: { key: 'ok_q8_answer_4' } },
      { id: 4, text: { key: 'ok_q8_answer_5' } },
    ],
  },
  212: {
    id: 212,
    progress: percentStep * 12,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ok_q9_question' },
    prevLink: 211,
    nextLink: 213,
    options: [
      { id: 0, text: { key: 'ok_q9_answer_1' } },
      { id: 1, text: { key: 'ok_q9_answer_2' } },
      { id: 2, text: { key: 'ok_q9_answer_3' } },
      { id: 3, text: { key: 'ok_q9_answer_4' } },
    ],
  },
  213: {
    id: 213,
    progress: percentStep * 13 - 1,
    type: QUESTIONS_TYPE.KEGEL_EFFECTIVENESS,
    nextLink: 214,
    prevLink: 212,
    s4: {
      title: 'ok_s5_title',
      image: 'img_erection_84.webp',
      review: [7],
      buttons: true,
    },
  },
  214: {
    id: 214,
    progress: percentStep * 14 - 1,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ok_q10_question' },
    nextLink: 215,
    prevLink: 213,
    leftRate: { key: 'ok_q10_rate_low' },
    rightRate: { key: 'ok_q10_rate_high' },
  },
  215: {
    id: 215,
    progress: percentStep * 15 - 2,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ok_q11_question' },
    prevLink: 214,
    nextLink: 216,
    options: [
      { id: 0, text: { key: 'ok_q11_answer_1' } },
      { id: 1, text: { key: 'ok_q11_answer_2' } },
      { id: 2, text: { key: 'ok_q11_answer_3' } },
      { id: 3, text: { key: 'ok_q11_answer_4' } },
    ],
  },
  216: {
    id: 216,
    progress: percentStep * 16 - 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ok_q12_question' },
    prevLink: 215,
    nextLink: 217,
    options: [
      { id: 0, text: { key: 'ok_q12_answer_1' } },
      { id: 1, text: { key: 'ok_q12_answer_2' } },
      { id: 2, text: { key: 'ok_q12_answer_3' } },
      { id: 3, text: { key: 'ok_q12_answer_4' } },
      { id: 4, text: { key: 'ok_q12_answer_5' } },
    ],
  },
  217: {
    id: 217,
    progress: percentStep * 17 - 3,
    type: QUESTIONS_TYPE.GOALS_REVIEWS,
    titleKey: 'ok_pp1_title',
    goalKey: 'ok_pp1_improve_goal',
    byDateKey: 'ok_pp1_by_date',
    noteKey: 'ok_pp1_illustration_note',
    reviewsTitleKey: 'ok_pp1_customer_reviews_title',
    showMoreButtonKey: 'ok_pp1_show_more_button',
    prevLink: 216,
    nextLink: 218,
  },
  218: {
    id: 218,
    progress: percentStep * 18 - 3,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ok_q13_question' },
    prevLink: 217,
    nextLink: 219,
    leftRate: { key: 'ok_q13_rate_low' },
    rightRate: { key: 'ok_q13_rate_high' },
  },
  219: {
    id: 219,
    progress: percentStep * 19 - 2,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ok_q14_question' },
    prevLink: 218,
    nextLink: 220,
    options: [
      { id: 0, text: { key: 'ok_q14_answer_1' } },
      { id: 1, text: { key: 'ok_q14_answer_2' } },
      { id: 2, text: { key: 'ok_q14_answer_3' } },
      { id: 3, text: { key: 'ok_q14_answer_4' } },
    ],
  },
  220: {
    id: 220,
    progress: percentStep * 20 - 3,
    type: QUESTIONS_TYPE.KEGEL_BENEFITS,
    titleKey: 'ok_s6_title',
    sourceKey: 'ok_s6_source',
    sourceNameKey: 'ok_s6_source_name',
    nextLink: 221,
    prevLink: 219,
    s5: {
      base: 'img_pills_vs_kegel_Erection_Stamina.webp',
    },
  },
  221: {
    id: 221,
    progress: percentStep * 21,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ok_q15_question' },
    prevLink: 220,
    nextLink: 222,
    options: [
      { id: 0, text: { key: 'ok_q15_answer_1' } },
      { id: 1, text: { key: 'ok_q15_answer_2' } },
      { id: 2, text: { key: 'ok_q15_answer_3' } },
      { id: 3, text: { key: 'ok_q15_answer_4' } },
      { id: 4, text: { key: 'ok_q15_answer_5' } },
    ],
  },
  222: {
    id: 222,
    progress: percentStep * 22,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'ok_q16_question' },
    prevLink: 221,
    nextLink: 223,
    options: [
      { id: 0, text: { key: 'ok_q16_answer_1' } },
      { id: 1, text: { key: 'ok_q16_answer_2' } },
      { id: 2, text: { key: 'ok_q16_answer_3' } },
    ],
  },
  223: {
    id: 223,
    progress: percentStep * 23,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ok_q17_question' },
    prevLink: 222,
    nextLink: 224,
    leftRate: { key: 'ok_q17_rate_low' },
    rightRate: { key: 'ok_q17_rate_high' },
  },
  224: {
    id: 224,
    progress: percentStep * 24,
    type: QUESTIONS_TYPE.GOALS,
    titleKey: 'ok_pp2_title',
    goalKey: 'ok_pp1_improve_goal',
    addGoalKey: 'ok_pp2_improve_goal',
    byDateKey: 'ok_pp2_by_date',
    noteKey: 'ok_pp2_illustration_note',
    durationKey: 'ok_pp2_exercise_duration',
    equipKey: 'ok_pp2_required_equipment',
    exNoteKey: 'ok_pp2_exercise_note',
    prevLink: 223,
    nextLink: 225,
  },
  225: {
    id: 225,
    progress: percentStep * 25,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ok_q18_question' },
    prevLink: 224,
    nextLink: 226,
    leftRate: { key: 'ok_q18_rate_low' },
    rightRate: { key: 'ok_q18_rate_high' },
  },
  226: {
    id: 226,
    progress: 100,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'ok_q19_question' },
    prevLink: 225,
    nextLink: '/quiz/health-onboarding',
    leftRate: { key: 'ok_q19_rate_low' },
    rightRate: { key: 'ok_q19_rate_high' },
  },
};
